import "./Stage0LifeMeter.css";
import { useEffect, useState } from "react";

export default function Stage0LifeMeterUI({ playerMode }) {
  const [showPie, setShowPie] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPie(true);
    }, 9500); // matches your current boot-row-4 timing

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="stage0-life-meter-container stage0-meter-boot">
      {playerMode === "plant" ? (
        <>
          <div className="stage0-meter-row water-meter boot-row boot-row-1">
            <span className="stage0-meter-icon">💧</span>
            <div className="stage0-meter-bar" />
          </div>

          <div className="stage0-meter-row sun-meter boot-row boot-row-2">
            <span className="stage0-meter-icon">☀️</span>
            <div className="stage0-meter-bar" />
          </div>

          <div className="stage0-meter-row nutrient-meter boot-row boot-row-3">
            <span className="stage0-meter-icon">🌱</span>
            <div className="stage0-meter-bar" />
          </div>

          {showPie && (
            <div className="stage0-pie-chart">
              <img
                src="/stageAssets/stage0/pieChart-forSystemsLoading-Plant.gif"
                alt="Plant systems chart"
              />
            </div>
          )}
        </>
      ) : (
        <>
          <div className="stage0-meter-row cycle-meter boot-row boot-row-1">
            <span className="stage0-meter-icon">🌗</span>
            <div className="stage0-meter-bar" />
          </div>

          <div className="stage0-meter-row temperature-meter boot-row boot-row-2">
            <span className="stage0-meter-icon">🌡️</span>
            <div className="stage0-meter-bar" />
          </div>

          <div className="stage0-meter-row energy-meter boot-row boot-row-3">
            <span className="stage0-meter-icon">⚡</span>
            <div className="stage0-meter-bar" />
          </div>

          {showPie && (
            <div className="stage0-pie-chart boot-row boot-row-4">
              <img
                src="/stageAssets/stage0/pieChart-forSystemsLoading-Human.gif"
                alt="Human systems chart"
              />
            </div>
          )}
        </>
      )}
    </div>
  );
}